<template>
	<section class="key-features" :style="sectionVars">
		<div class="container key-features__container">
			<div class="key-features__content">
				<h2
					v-if="title"
					class="key-features__title headline-l"
					v-html="title"
				></h2>

				<div class="key-features__grid">
					<div
						v-for="(feature, index) in features"
						:key="index"
						class="key-features__item"
					>
						<img
							v-if="feature.icon"
							class="key-features__icon"
							:src="feature.icon"
							alt=""
						/>
						<span class="key-features__text" v-html="feature.title"></span>
					</div>
				</div>

				<div v-if="$slots.footer" class="key-features__footer">
					<slot name="footer" />
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'KeyFeatures',
	props: {
		title: { type: String, default: '' },

		backgroundImage: { type: String, required: true },
		backgroundColor: { type: String, default: '#040428' },
		backgroundPosition: { type: String, default: 'center' },
		backgroundSize: { type: String, default: 'cover' },

		mobileBackgroundImage: { type: String, required: true },

		features: {
			type: Array,
			default: () => [],
			// { icon?: string, title: string }
		},

		cardBg: { type: String, default: '#4656FF' },
		borderColor: { type: String, default: '#6464FF' },
		textColor: { type: String, default: '#FFFFFF' },
	},
	computed: {
		sectionVars() {
			return `
        --bg: ${this.backgroundColor};
        --bg-image: url('${this.backgroundImage}');
        --bg-mobile-image: url('${this.mobileBackgroundImage}');
        --bg-pos: ${this.backgroundPosition};
        --bg-size: ${this.backgroundSize};
        --card-bg: ${this.cardBg};
        --border: ${this.borderColor};
        --text: ${this.textColor};
      `;
		},
	},
};
</script>

<style lang="scss" scoped>
.key-features {
	width: 100%;
	background-color: var(--bg);
	background-image: var(--bg-image);
	background-repeat: no-repeat;
	background-position: var(--bg-pos);
	background-size: var(--bg-size);

	border-bottom: 1px solid var(--border);

	padding: 64px 0;

	@media (max-width: $breakpoint-md) {
		padding: 40px 0;
	}

	@media (max-width: $breakpoint-sm) {
		padding: 40px 0;
		background-image: var(--bg-mobile-image);
	}
}

.key-features__container {
	@media (min-width: $breakpoint-lg) {
		max-width: 1196px;
	}
}

.key-features__content {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
}

.key-features__title {
	color: var(--text);
	text-transform: uppercase;
	font-weight: 800;
	margin-bottom: 80px;

	@media (max-width: $breakpoint-sm) {
		font-size: 28px;
		line-height: 35px;
		font-weight: 700;
		margin-bottom: 60px;
	}
}

.key-features__grid {
	width: 100%;
	max-width: 765px;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 30px;

	@media (max-width: $breakpoint-sm) {
		grid-template-columns: repeat(2, 1fr);
		gap: 16px;
	}
}

.key-features__item {
	background: var(--card-bg);
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	padding: 14px 14px;
	min-height: 51px;

	@media (max-width: $breakpoint-sm) {
		flex-direction: column;
		padding: 10px 12px 12px 12px;
		gap: 8px;
		min-height: 72px;
	}
}

.key-features__icon {
	width: 25px;
	height: 25px;
	object-fit: contain;
	flex-shrink: 0;
}

.key-features__text {
	font-family: 'HKNova-Bold', sans-serif;
	font-size: 16px;
	font-weight: 700;
	text-transform: uppercase;
	color: var(--text);
	line-height: 20px;
	text-align: left;

	@media (max-width: $breakpoint-sm) {
		text-align: center;
		font-size: 14px;
		line-height: 18px;
	}
}

.key-features__footer {
	margin-top: 18px;
}
</style>
